import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Layout from '@/components/Layout';
import { postOauth } from "@/api";
import { getUrlParam } from '@/utils/url';
import { initWxConfig } from '@/utils/wx';
import Bus from '@/utils/bus';
// import { showVcByType } from '@/utils/vconsole'
import { checkUesrId } from '@/utils/auth';
import { getPlatformType } from "@/utils/checkBrowser";
import obsServer from '@/utils/obsServer';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        Bus.$on('Unauthorized', () => {
            // console.log('bus Unauthorized')
            router.push({ name: 'Signin' });
        });
        Bus.$on('hideWelcomeLoading', () => {
            const welcomeLoading = document.getElementById('welcome');
            const welcomeText = document.getElementById('welcome-text');
            setTimeout(() => {
                welcomeText?.style.setProperty('display', 'none');
                welcomeLoading?.style.setProperty('display', 'none');
            }, 300);
        });
        initWxConfig();
        // 判断公众号截取code
        const wxCode = getUrlParam('code');
        const wxCallback = getUrlParam('callback');
        // const vcShow = getUrlParam('vc')
        // 页面关闭/隐藏时上报 obsServer 数据
        const handlePageHide = (event) => {
            obsServer.leavePageSync();
            if (!event.persisted) {
                sessionStorage.removeItem('bd_id');
            }
        };
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                obsServer.leavePageSync();
            }
        };
        onMounted(() => {
            // if (vcShow) {
            //   setTimeout(() => {
            //     showVcByType()
            //   }, 1200)
            // }
            // TODO 浩海和毅新接口调用位置
            // postAdsIncrease({entitys:[...withdrawalListPageData,...userPageData,...paymentSuccessData,...infoPageData,...homePageData]}).then()
            // 监听页面关闭/隐藏事件，确保 H5 关闭时上报数据
            window.addEventListener('pagehide', handlePageHide);
            document.addEventListener('visibilitychange', handleVisibilityChange);
        });
        onBeforeUnmount(() => {
            window.removeEventListener('pagehide', handlePageHide);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });
        if (wxCode) {
            let app_id = getPlatformType() === 'kuaishou' ? process.env.VUE_APP_KUAISHOU_APPID : process.env.VUE_APP_APPID;
            let platform = getPlatformType() === 'kuaishou' ? 'ks' : 'oa';
            debugger;
            postOauth({
                app_id: app_id,
                platform: platform,
                scope: 'info',
                code: wxCode
            }).then(res => {
                localStorage.setItem('yc_token', res.token);
                const callback = handleCallbackUrl();
                // console.log(callback)
                // console.log('wxCallback=', wxCallback)
                // console.log('wxcode=', wxCode)
                // console.log('callback=', router.currentRoute.value.query.callback)
                // console.log('code=', router.currentRoute.value.query.code)
                // console.log(router.currentRoute.value)
                // debugger
                console.log(callback);
                if (checkUesrId(callback)) {
                    if (res.user_id === 0) {
                        // console.log(res)
                        // 需要绑定手机号 oauth_flag
                        router.push({
                            name: 'BindingPhone',
                            query: {
                                oauth_flag: res.oauth_flag,
                                callback
                            }
                        });
                    }
                    else {
                        window.location.href = process.env.VUE_APP_BACKURL + callback;
                    }
                }
                else {
                    // 直接存储token 后续捐款流程
                    window.location.href = process.env.VUE_APP_BACKURL + callback;
                }
            });
        }
        function handleCallbackUrl() {
            if (getPlatformType() === 'kuaishou') {
                const state = getUrlParam('state');
                return JSON.parse(decodeURIComponent(atob(state))).callback;
            }
            else {
                return wxCallback;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Suspense, null, {
                default: _withCtx(() => [
                    _createVNode(_unref(Layout))
                ]),
                _: 1
            }));
        };
    }
});
